import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from '../containers/about';
import ForgotPassword from '../containers/authPage/forgot';
import Login from '../containers/authPage/login';
import OTP from '../containers/authPage/otp';
import Register from "../containers/authPage/register";
import Contact from '../containers/contact';
import DetailsPage from '../containers/detailsPage';
import Home from '../containers/home/index';
import ListMyPlan from '../containers/listMyPlan';
import EditPlan from '../containers/user/editPlan';
import ViewProfile from '../containers/user/viewProfile';

const Routers = () => {
  return (
    <BrowserRouter>
      {/* <Header /> */}
      <Routes>
        <Route index element={<Home />} />
        <Route path='/details/:plan_name' element={<DetailsPage />} />
        <Route path='/editplan/:plan_name' element={<EditPlan />} />
        <Route path="/login" element={<Login/>} />
        <Route path="/register" element={<Register/>} />
        <Route path="/forgotpassword" element={<ForgotPassword/>} />
        <Route path="/otp" element={<OTP/>} />
        <Route path="/list-my-plan" element={<ListMyPlan/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/user/viewprofile" element={<ViewProfile/>} />
      </Routes>
      {/* <Footer /> */}
    </BrowserRouter>
  )
}

export default Routers;